export default {
  text: 'Ganhou {{points}} pontos ({{amount}}) nesta encomenda',
  button: 'Iniciar sessão e Reclamar Pontos',
};
